{
  "LOGIN": {
    "TITLE": "Se connecter au centre de contact",
    "EMAIL": {
      "LABEL": "Courriel",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "Veuillez saisir une adresse de courriel valide"
    },
    "PASSWORD": {
      "LABEL": "Mot de passe",
      "PLACEHOLDER": "Mot de passe"
    },
    "API": {
      "SUCCESS_MESSAGE": "Connexion réussie",
      "ERROR_MESSAGE": "Impossible de se connecter au serveur Woot, veuillez réessayer plus tard",
      "UNAUTH": "Nom d'utilisateur / Mot de passe incorrect. Veuillez réessayer.",
      "ACCOUNT_DEACTIVATED": "Votre compte a été désactivé. Veuillez contacter votre administrateur.",
      "PASSWORD_LOGIN_DISABLED": "La connexion par mot de passe est désactivée pour votre compte. Veuillez vous connecter via OAuth (par exemple Google)."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Se connecter avec Google",
      "BUSINESS_ACCOUNTS_ONLY": "Veuillez utiliser l'adresse e-mail de votre entreprise pour vous connecter",
      "NO_ACCOUNT_FOUND": "Nous n'avons pas pu trouver de compte pour votre adresse e-mail."
    },
    "FORGOT_PASSWORD": "Mot de passe oublié ?",
    "CREATE_NEW_ACCOUNT": "Créer un nouveau compte",
    "SUBMIT": "Se connecter"
  }
}
